import { Row } from "antd";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { billDataModel } from "./billDataModel";
import { useGlobalModel } from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";

export const BillSearchBox = () => {

    const { accountTypeDs, tradeTypeDs, getSelectedDict } = useGlobalModel()
    const {
        searchParam,
        onSearch,
        onReset,
        updateSearchParam,
        loadData
    } = billDataModel();

    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "合约单号",
            fieldName: "code",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编号",
            fieldName: "tradeCode",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户类型",
            fieldName: "accountTypeName",
            size: "small",
            options: accountTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "签约类型",
            fieldName: "contractType",
            size: "small",
            disabled: false,
            options: getSelectedDict(DictCodeEnmu.CONTRACT_TYPE),
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "单据类型",
            fieldName: "tradeTypeCode",
            size: "small",
            disabled: false,
            options: tradeTypeDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset,
        }
    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
